import Link from '@/ui/Link';
import RatingMovie from '@/ui/RatingMovie';
// Стили
import './MovieSearchCard.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MovieSearchCard = function MovieSearchCard(_ref) {
    var _movie$releaseYear, _movie$genres;
    var movie = _ref.movie, onLinkClick = _ref.onLinkClick;
    return /*#__PURE__*/ _jsxs("div", {
        className: "movie-search-card",
        children: [/*#__PURE__*/ _jsx("img", {
                className: "movie-search-card__img",
                src: movie.posterUrl,
                width: 40,
                height: 52,
                alt: "\u041F\u043E\u0441\u0442\u0435\u0440 \u0444\u0438\u043B\u044C\u043C\u0430 ".concat(movie.title)
            }), /*#__PURE__*/ _jsxs("div", {
                className: "movie-search-card__content",
                children: [/*#__PURE__*/ _jsxs("div", {
                        className: "movie-search-card__info",
                        children: [/*#__PURE__*/ _jsx(RatingMovie, {
                                value: movie.tmdbRating,
                                size: "sm"
                            }), /*#__PURE__*/ _jsx("span", {
                                className: "movie-search-card__text",
                                children: (_movie$releaseYear = movie.releaseYear) !== null && _movie$releaseYear !== void 0 ? _movie$releaseYear : '—'
                            }), /*#__PURE__*/ _jsx("span", {
                                className: "movie-search-card__text",
                                children: ((_movie$genres = movie.genres) === null || _movie$genres === void 0 ? void 0 : _movie$genres.join(', ')) || 'Жанр не указан'
                            }), /*#__PURE__*/ _jsx("span", {
                                className: "movie-search-card__text",
                                children: movie.runtime ? "".concat(movie.runtime, " \u043C\u0438\u043D.") : '—'
                            })]
                    }), /*#__PURE__*/ _jsx(Link, {
                        to: "/movie/".concat(movie.id),
                        className: "movie-search-card__link",
                        onClick: onLinkClick,
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "movie-search-card__title",
                            children: movie.title || 'Без названия'
                        })
                    })]
            })]
    });
};
export default MovieSearchCard;
